import React from "react";
import { Link } from "react-router-dom";
import { Mail, Send } from "lucide-react";
import teamImage from "../assets/career.jpg";
import careersBkg from "../assets/careers-bkg.jpg";

export default function Careers() {
  return (
    <section className="min-h-screen bg-white text-gray-800 font-sans pb-20">
      {/* Sleek Dark Hero Banner */}
      <div
        className="relative bg-cover bg-center text-white py-20 px-4 text-center shadow-lg"
        style={{ backgroundImage: `url(${careersBkg})` }}
      >
        <div className="absolute inset-0 bg-slate-950/60 backdrop-blur-[1px]"></div>
        <div className="relative z-10">
          <h1 className="text-4xl sm:text-5xl font-bold mb-2">Career</h1>
          <p className="text-sm text-slate-300 font-medium">
            <Link to="/" className="hover:text-pink-500 transition duration-200">Home</Link>
            <span className="mx-1.5 text-slate-500">/</span>
            <Link to="/careers" className="text-pink-400 hover:text-pink-500 transition duration-200">Career</Link>
          </p>
        </div>
      </div>

      {/* Meet the Team Section */}
      <div className="max-w-6xl mx-auto py-16 px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div data-aos="fade-right" className="space-y-6">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 leading-tight">
              Meet the Team Behind Our Success & Innovation
            </h2>
            <p className="text-gray-650 text-sm sm:text-base leading-relaxed">
              At Atronm, we believe that groundbreaking technology is built by exceptional people. Our team brings together talented software engineers, AI specialists, product designers, and strategy experts who share a single mission: to solve complex business challenges with absolute sincerity and technical excellence.
            </p>
            <p className="text-gray-650 text-sm sm:text-base leading-relaxed mt-4">
              We foster a collaborative ecosystem where creativity meets performance optimization. By blending deep domain expertise with agile execution, we engineer high-performance systems that empower businesses to scale globally. When you work with us, you are joining dedicated minds focused on learning, growing, and building the future.
            </p>
          </div>

          <div data-aos="fade-left" className="relative group flex justify-center">
            <div className="absolute -inset-1 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl blur opacity-25 group-hover:opacity-45 transition duration-1000"></div>
            <img
              src={teamImage}
              alt="Atronm Team Working"
              className="relative rounded-2xl shadow-xl w-full max-w-md object-cover transition-transform duration-500 hover:scale-[1.01]"
              loading="eager"
            />
          </div>
        </div>

        {/* No Open Positions / Speculative Application Section */}
        <div className="max-w-3xl mx-auto text-center py-12 px-6 bg-slate-50 rounded-3xl border border-slate-100 relative overflow-hidden group shadow-sm hover:shadow-[0_20px_50px_rgba(59,130,246,0.05)] transition-all duration-300" data-aos="fade-up">
          {/* Subtle background glow */}
          <div className="absolute -top-24 -left-24 w-48 h-48 bg-blue-400/10 rounded-full blur-3xl pointer-events-none group-hover:bg-blue-400/15 transition duration-500"></div>
          <div className="absolute -bottom-24 -right-24 w-48 h-48 bg-purple-400/10 rounded-full blur-3xl pointer-events-none group-hover:bg-purple-400/15 transition duration-500"></div>
          
          <div className="relative z-10 space-y-6">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-50 text-blue-600 mb-2">
              <Mail size={32} />
            </div>
            
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
              Currently Open Positions
            </h2>
            
            <p className="text-gray-650 text-sm sm:text-base leading-relaxed max-w-xl mx-auto">
              We do not have any active job openings at the moment. However, we are always on the lookout for talented, passionate developers, designers, and innovators to join our team.
            </p>
            
            <p className="text-gray-650 text-sm sm:text-base leading-relaxed max-w-xl mx-auto font-medium">
              If you think you'd be a great fit for Atronm, please share your resume with us for future opportunities.
            </p>
            
            <div className="pt-4">
              <a
                href="mailto:hr@atronm.com?subject=Speculative%20Application%20-%20[Your%20Name]&body=Hi%20Atronm%20Team,%0D%0A%0D%0AI%20am%20interested%20in%20joining%20Atronm.%20Please%20find%20my%20attached%20resume%20for%20future%20opportunities.%0D%0A%0D%0ARegards,%0D%0A[Your%20Name]"
                className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 hover:scale-105 hover:shadow-[0_0_20px_rgba(37,99,235,0.4)] text-white font-semibold py-3 px-8 rounded-full shadow-lg transition-all duration-300"
              >
                <Send size={18} /> Share Your Resume (hr@atronm.com)
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
